/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IssueConformityCredentialDto { 
    /**
     * DID of the credential subject
     */
    subjectDid: string;
    /**
     * Type of conformity credential to issue
     */
    credentialType: IssueConformityCredentialDto.CredentialTypeEnum;
    /**
     * Provider/organization name for the credential subject
     */
    providerName?: string;
}
export namespace IssueConformityCredentialDto {
    export const CredentialTypeEnum = {
        GbaApprovedVerifierCredential: 'GBAApprovedVerifierCredential',
        GbaApprovedCertifierCredential: 'GBAApprovedCertifierCredential',
        GbaApprovedCarbonCalculationPartnerCredential: 'GBAApprovedCarbonCalculationPartnerCredential'
    } as const;
    export type CredentialTypeEnum = typeof CredentialTypeEnum[keyof typeof CredentialTypeEnum];
}


